export function isValidPhone(phone: string | null | undefined): boolean {
	if (!phone) return true;
	const cleaned = phone.replace(/[\s\-().]/g, "");
	if (/^(\+90|0)?5\d{9}$/.test(cleaned)) return true;
	return /^\+?\d{7,15}$/.test(cleaned);
}
